import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import General from "./modules/General";
import Requirement from "./modules/Requirement";
import AForm from "./modules/AForm";
import BForm from "./modules/BForm";
import CForm from "./modules/CForm";
import Auth from "./modules/Auth";
import MainProject from "./modules/MainProject";
import Plan from "./modules/Plan";
import MonthlyProgress from "./modules/MonthlyProgress";
import Extend from "@/store/modules/Extend";
import USPExtend from "@/store/modules/USPExtend";
import RSPExtend from "@/store/modules/RSPExtend";
import SPExtend from "@/store/modules/SPExtend";
import Attachment from "./modules/Attachment";
import Consider from "./modules/Consider";
import Dashboard from "./modules/Dashboard";
import Request from './modules/Request';
import UserServiceHistory from './modules/UserServiceHistory';
import CalendarActivity from "./modules/CalendarActivity";
import TechnologyEvaluation from "./modules/TechnologyEvaluation";
import Fundamental from "./modules/Fundamental";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    General,
    Requirement,
    AForm,
    BForm,
    CForm,
    Auth,
    MainProject,
    Plan,
    MonthlyProgress,
    Attachment,
    Extend,
    USPExtend,
    RSPExtend,
    SPExtend,
    Consider,
    Dashboard,
    Request,
    UserServiceHistory,
    CalendarActivity,
    TechnologyEvaluation,
    Fundamental
  },
  plugins: [createPersistedState()],
});
